import React from 'react';
import TeamList from 'components/TeamList';

const Team = () => {
  return <TeamList />;
};

export default Team;
